/** Color de fondo por defecto mientras la imagen carga o si falla (placeholder neutro). */
export const POSTER_DEFAULT_COLOR = 'var(--color-gray-20)'

/** `sizes` por defecto para `next/image` en modo `fill` (ancho completo del contenedor). */
export const POSTER_DEFAULT_SIZES = '100vw'
